export default __webpack_public_path__ + "static/media/paprika_jancsi_etterem_10.8311dda1.JPG";